//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userSignin from '~/components/login/userSigin.vue' // 登录框左侧
import userDealer from '~/components/login/userDealer.vue'
import userRegister from '~/components/login/userRegister.vue' // 注册
import userReset from '~/components/login/userReset.vue' // 重置
import userQrcode from '~/components/login/userQrcode.vue' // 二维码
import userMpopup from '~/components/login/userMpopup.vue' // m端登录弹框
export default {
  components: {
    'user-sigin': userSignin, // 登录框
    'user-reset': userReset, // 验证码
    'user-register': userRegister, // 注册
    'user-qrcode': userQrcode, // 二维码
    'user-dealer': userDealer, // 交易商
    'user-mpopup': userMpopup // 交易商
  },
  layout: 'common',
  data () {
    return {
      loginCode: this.$route.query.type == 'register' ? 2 : 1, // 1.手机号+验证码 2.注册 3.重置
      currentAddress: this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1), // 当前页面地址
      phone: '', // 输入的手机号
      verifCode: '', // 验证码
      requestId: '', // 登录极验id
      disbl: this.$route.query.type == 'register' // m端登录是否展示
    }
  },
  computed: {
    title () {
      if (this.loginCode == 2) {
        return this.$v('注册')
      } else {
        return this.$v('验证码')
      }
    },
    voiceTitle () {
      if (this.loginCode == 2) {
        return this.$v('注册')
      } else {
        return this.$v('语言验证')
      }
    }
  },
  watch: {
    close (newValue) { // 搜索后的列表
      this.loginCode = 1
    }
  },
  methods: {
    close () {
      this.$store.commit('loginClose', false)
      this.loginCode = 1 // 切换为账号/手机登录
      this.phone = this.verifCode = this.requestId = ''
      this.disbl = false // m端默认展示,根据页面大小使用媒体判断pc是否出现
      // this.$nextTick(() => {
      //   document.querySelector('.wiki-head').style.display = 'block'
      // })
    },
    loginSwitch (i) { // 切换状态
      this.loginCode = i
    },
    loginMswitch (i) { // m切换状态
      this.disbl = true
      this.loginCode = i
    },
    cellphoneNumber (i) { // 手机号
      this.phone = i
      console.log('phone: ', this.phone)
    },
    verCode (code) { // 验证码
      this.verifCode = code
    },
    getRequestId (id) { // 登录未注册传进来的id
      this.requestId = id
    }
  }
}
